export const PHYSICS = {
  labId: 'physics',
  title: 'Engineering Physics Playground',
  benches: [
    { id: 'forces', title: 'Forces on the floor', path: '/virtuallabs/physics/forces', lessonTitle: 'Make it move' },
    { id: 'energy', title: 'Energy & work', path: '/virtuallabs/physics/energy', lessonTitle: 'Spend the height' },
    { id: 'rotation', title: 'Torque & inertia', path: '/virtuallabs/physics/rotation', lessonTitle: 'Spin the shaft' },
    { id: 'vibration', title: 'Mass-spring-damper', path: '/virtuallabs/physics/vibration', lessonTitle: 'Kill the shake' },
    { id: 'fluids', title: 'Bernoulli line', path: '/virtuallabs/physics/fluids', lessonTitle: 'Read the pipe' },
    { id: 'heat', title: 'Heat path', path: '/virtuallabs/physics/heat', lessonTitle: 'Dump the watts' },
  ],
};

export const SEMICON_MECH = {
  labId: 'semicon-mech',
  title: 'Semiconductor Mechanical Studio',
  benches: [
    { id: 'warpage', title: 'Stack & warpage', path: '/virtuallabs/semicon-mech/warpage', lessonTitle: 'Bow the package' },
    { id: 'peel-shear', title: 'Peel / shear bench', path: '/virtuallabs/semicon-mech/peel-shear', lessonTitle: 'Peel the joint' },
    { id: 'defence', title: 'Brief the senior', path: '/virtuallabs/semicon-mech/defence', lessonTitle: 'Defend the call' },
  ],
};

const ALL = [PHYSICS, SEMICON_MECH];

export function benchPath(labId, benchId, ctx) {
  const studio = ALL.find((s) => s.labId === labId);
  const b = studio?.benches.find((x) => x.id === benchId);
  let path = b ? b.path
    : labId === 'medphysics' ? `/virtuallabs/physics/${benchId || ''}`.replace(/\/$/, '')
    : labId ? `/virtuallabs/${labId}` : '/virtuallabs';

  // Carry course/lesson context through so a graded bench (e.g. the semicon-mech
  // defence) can record its result against the right capstone submission.
  if (ctx?.courseId && ctx?.sectionIndex !== undefined && ctx?.lessonIndex !== undefined) {
    const params = new URLSearchParams({
      courseId: ctx.courseId,
      si: String(ctx.sectionIndex),
      li: String(ctx.lessonIndex),
    });
    path += `?${params.toString()}`;
  }
  return path;
}

export function isLabLesson(lesson = {}) {
  return lesson.type === 'lab' || lesson.type === 'project' || Boolean(lesson.labId);
}
